import { useEffect, useState } from 'react';
import NavMenuItem from "./NavMenuItem";
import RecallsIcon from "../../../assets/icons/icon-recalls.svg";
import CustomersIcon from "../../../assets/icons/icon-customers-white.svg";
import InventoryIcon from "../../../assets/icons/icon-inventory.svg";
import SettingsIcon from "../../../assets/icons/icon-settings.svg";
import MyAccountIcon from "../../../assets/icons/icon-myAccount.svg";
import DocumentationIcon from '../../../assets/icons/icon-documents-nav.svg';
import WorkstationsIcon from '../../../assets/icons/menu-icon-people-white.svg';
import Logo from "../../../assets/icons/CellTrak-logo.svg";
import { Establishments, Inventory, OperatorSettings, Documentation, Requests, Workstations } from "../../../modules/Navigation";
import { usePermissions } from '../../../modules/auth/Permissions/PermissionContext';
import { hasPermission } from '../../../modules/auth/Permissions/PermissionModule';
import { PermissionConcerns, PermissionTypes } from '../../../modules/auth/Permissions/PermissionStrings';
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from 'react-aria-components';
import { FormMemory } from '../entityComponents/Form/FormMemory';

export interface ISideMenu {
    showMobileMenu: boolean,
    setShowMobileMenu: Function,
    setHoveringMenu: Function,
    hoveringMenu: boolean,
    open: boolean
}

export default function NavMenu({ showMobileMenu, setShowMobileMenu, setHoveringMenu, hoveringMenu, open }: ISideMenu) {
    const [canAnimate, setCanAnimate] = useState(false);
    const { permissions } = usePermissions();
    const { logout } = useAuth0();

    useEffect(() => {
        setCanAnimate(true);
    }, []);

    const navMenuItems = {
        establishments: <NavMenuItem text={Establishments.title}
            icon={CustomersIcon}
            navigateTo={Establishments.to}
            className='padding__left--s' />,

        operatorSettings: <NavMenuItem text={OperatorSettings.title}
            icon={SettingsIcon}
            navigateTo={OperatorSettings.to}
            className='padding__left--s' />,

        documentation: <NavMenuItem text={Documentation.title}
            icon={DocumentationIcon}
            navigateTo={Documentation.to}
            className='padding__left--s' />,

        requests: <NavMenuItem text={Requests.title}
            icon={RecallsIcon}
            navigateTo={Requests.to}
            className='padding__left--s' />,

        workstations: <NavMenuItem text={Workstations.title}
            icon={WorkstationsIcon}
            navigateTo={Workstations.to}
            className='padding__left--s' />,
    };

    return <>
        <div className={`nav-menu__mobile-backing ${showMobileMenu === true ? "active" : ""}`} onClick={() => setShowMobileMenu(false)} ></div>
        <div data-testid={"nav-menu"} className={`nav-menu ${!open ? "nav-menu--closed" : ""} ${canAnimate === true ? "nav-menu--animation" : ""} ${showMobileMenu === true ? "nav-menu__mobile-menu-open" : "nav-menu__mobile-menu-closed"}`} onMouseEnter={() => setHoveringMenu(true)} onMouseLeave={() => setHoveringMenu(false)} >
            <div className={"grid-y nav-menu__column"}>
                <div className='padding__left--s'>
                    <img alt='logo' src={Logo} />
                </div>

                <div className={"cell auto nav-menu__main-nav-wrapper margin__top--l"}>

                    {/* <NavMenuItem text={Root.title}
                        icon={DashboardIcon}
                        navigateTo={Root.to}
                        className='padding__left--s' /> */}

                    {
                        (hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Cases_And_Ranges) ||
                            hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Specimens) ||
                            hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Inventory_Containers)) ?
                            <NavMenuItem text={Inventory.title}
                                icon={InventoryIcon}
                                navigateTo={Inventory.to}
                                className='padding__left--s' /> : null
                    }

                    {
                        (hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Customers) ||
                            hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Accounts)) ? navMenuItems.establishments : null
                    }

                    {
                        (hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Make_Recall_Request) ||
                            hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Make_Disposal_Request) ||
                            hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Recall_Requests) ||
                            hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Manage_Recalls)) ? navMenuItems.requests : null
                    }

                    {
                        hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Documentation) ? navMenuItems.documentation : null
                    }

                    {
                        hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Workstations) ? navMenuItems.workstations : null
                    }
                    {
                        hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Navigation_Settings_Cellnass) ? navMenuItems.operatorSettings : null
                    }
                </div>
                <div>
                    <Button className="nav-menu__item padding__left--s"
                        onPress={() => {
                            FormMemory.clearAll();
                            logout({ logoutParams: { returnTo: process.env.REACT_APP_URL } });
                        }}>
                        <img className={"nav-menu__active-icon margin__left--xxxs"} src={MyAccountIcon} />
                        <p className={"nav-menu__item__text"}>
                            Logout
                        </p>
                    </Button>
                </div>
            </div>
        </div>
    </>
};